import Axios from 'axios';
import { Order } from 'kiolyn-api';
import { isEmpty } from 'lodash';
import { DSOrder } from '../components/KitchenDisplayPage/StatusTypeList.stories';
import IMainStationRepository from '../domain/repositories/IMainStationRepository';

export default class MainStationRepository implements IMainStationRepository {
  private readonly basePath: string;
  private readonly wsBasePath: string;
  private readonly port = '25610';

  constructor(ipAddress: string, storeId: string) {
    if (isEmpty(ipAddress) || isEmpty(storeId)) {
      throw Error('Missing required parameter for main station api');
    }
    this.basePath = `http://${ipAddress}:${this.port}/store/${storeId}`;
    this.wsBasePath = `ws://${ipAddress}:${this.port}/event`;
  }

  getWebsocket(): WebSocket {
    return new WebSocket(this.wsBasePath);
  }

  async listOrders(): Promise<Order[]> {
    var result = await Axios.get(`${this.basePath}/order/status-board`);
    if (result.data === null) {
      return [];
    }

    return result.data;
  }

  async loadOrderById(id: string): Promise<Order | null> {
    var result = await Axios.get(`${this.basePath}/order/status-board/${id}`);
    return result.data;
  }

  async listKitchenDisplayOrders(kitchenDisplayId: string): Promise<Order[]> {
    var result = await Axios.get(
      `${this.basePath}/orders/kitchen-display/${kitchenDisplayId}`
    );
    if (result.data === null) {
      return [];
    }

    return result.data;
  }

  async loadKitchenDisplayOrderById(
    kitchenDisplayId: string,
    id: string
  ): Promise<Order | null> {
    var result = await Axios.get(
      `${this.basePath}/order/${id}/kitchen-display/${kitchenDisplayId}`
    );
    return result.data;
  }

  async saveKitchenDisplayOrder(order: DSOrder): Promise<string> {
    var result = await Axios.post(
      `${this.basePath}/order/kitchen-display/save`,
      order
    );
    return result.data;
  }
}
